const NUM = /^(\d+(\.\d{1,2})?|\.\d{1,2})$/;
const clean = (v) => String(v ?? "").replace(/,/g, "").replace(/₹/g, "").trim();
const rnd = (x) => Math.round(x + 1e-7);

export const uid = () => Math.random().toString(36).slice(2, 10);

export function parseNum(v, max) {
  const s = clean(v);
  if (s === "") return { empty: true };
  if (s.startsWith("-")) return { err: "Cannot be negative" };
  if (!NUM.test(s)) return { err: "Number, max 2 decimals" };
  const n = Number(s);
  if (max != null && n > max) return { err: `Max ${max}` };
  return { n };
}

export function calcRow(r, method, shift, dupCodes) {
  const e = {};
  if (!clean(r.code)) e.code = "Required";
  else if (dupCodes.has(clean(r.code).toUpperCase())) e.code = "Duplicate ID";
  if (!String(r.name ?? "").trim()) e.name = "Required";
  const sal = parseNum(r.salary, 1e9);
  const days = parseNum(r.days, 31);
  const hrs = parseNum(r.hours, 744);
  const ded = parseNum(r.deduction, 1e9);
  if (sal.empty) e.salary = "Required"; else if (sal.err) e.salary = sal.err;
  if (days.empty) e.days = "Required"; else if (days.err) e.days = days.err;
  if (hrs.err) e.hours = hrs.err;
  if (ded.err) e.deduction = ded.err;
  const out = { errors: e, salary: 0, daily: 0, hourly: null, hoursUsed: null, earned: 0, deduction: 0, final: 0 };
  if (e.salary || e.days || e.hours || (method === "hour" && !(shift > 0))) return out;
  const S = rnd(sal.n * 100);
  out.salary = S;
  out.daily = rnd(S / 30);
  if (method === "hour") {
    out.hoursUsed = hrs.empty ? days.n * shift : hrs.n;
    out.hourly = rnd(S / (30 * shift));
    out.earned = rnd((S * out.hoursUsed) / (30 * shift));
  } else {
    out.earned = rnd((S * days.n) / 30);
  }
  out.deduction = ded.empty || ded.err ? 0 : rnd(ded.n * 100);
  if (out.deduction > out.earned) e.deduction = "Exceeds earned salary";
  out.final = out.earned - out.deduction;
  return out;
}

export function duplicateCodes(rows) {
  const seen = new Set(), dup = new Set();
  rows.forEach((r) => {
    const c = clean(r.code).toUpperCase();
    if (!c) return;
    if (seen.has(c)) dup.add(c);
    seen.add(c);
  });
  return dup;
}

export const shiftValue = (s) => {
  const p = parseNum(s, 24);
  return p.n > 0 ? p.n : null;
};

export const payloadRows = (rows) => rows.map(({ code, name, salary, days, hours, deduction }) => ({ code, name, salary: clean(salary), days: clean(days), hours: clean(hours), deduction: clean(deduction) || "0" }));

export const fromSaved = (run) =>
  run.rows.map((r) => ({ _id: uid(), code: r.code, name: r.name, salary: r.salary.toFixed(2), days: r.days, hours: r.actual_hours ?? "", deduction: r.deduction.toFixed(2) }));
